(function(){
  document.documentElement.classList.add('js');
  // reveal on scroll
  var els=[].slice.call(document.querySelectorAll('.reveal'));
  if('IntersectionObserver' in window){
    var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-in');io.unobserve(e.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(el){io.observe(el)});
  } else els.forEach(function(el){el.classList.add('is-in')});
  // header border
  var hdr=document.querySelector('[data-hdr]');
  var onScroll=function(){if(hdr)hdr.classList.toggle('is-scrolled',window.scrollY>8)};
  window.addEventListener('scroll',onScroll,{passive:true});onScroll();
  // hide sticky CTA while the form is on screen
  var sticky=document.querySelector('.sticky-start'),start=document.getElementById('start');
  if(sticky&&start&&'IntersectionObserver' in window){
    new IntersectionObserver(function(es){sticky.classList.toggle('is-away',es[0].isIntersecting)},{threshold:0.05}).observe(start);
  } else if(sticky&&!start){ sticky.classList.remove('is-away'); }

  // pincode gate: Thane only
  var form=document.getElementById('fera-enquiry');
  if(form){
    var thaneEl=form.querySelector('[data-thane]');
    var thane=(thaneEl?thaneEl.getAttribute('data-thane'):'').split(',').map(function(s){return s.trim()}).filter(Boolean);
    var pin=form.querySelector('#enq-pin'),msg=form.querySelector('[data-pin-msg]'),rest=form.querySelector('[data-rest]');
    var zone=form.querySelector('[data-zone]');
    var check=function(){
      var v=(pin.value||'').replace(/\D/g,'');pin.value=v;
      msg.className='field__msg';
      if(v.length<6){msg.textContent='';rest.hidden=true;return false;}
      if(thane.indexOf(v)>-1){
        if(zone)zone.value='Thane';msg.classList.add('ok');rest.hidden=false;
        msg.innerHTML='You’re in Thane. <a href="/products/fera-meal-pass">Buy food coupons here</a>, or send us a question below.';
        return true;
      }
      if(zone)zone.value='Outside Thane';msg.classList.add('bad');rest.hidden=true;
      msg.textContent='Sorry, we deliver only within Thane for now.';
      return false;
    };
    pin.addEventListener('input',check);check();
    form.addEventListener('submit',function(e){if(!check()){e.preventDefault();pin.focus();}});
  }
  var done=document.querySelector('[data-done]');
  if(done){document.getElementById('start').scrollIntoView();done.focus();}

  // menu filters
  var f=document.querySelector('[data-filters]');
  if(f){
    var dishes=[].slice.call(document.querySelectorAll('.dishes--full .dish'));
    var count=f.querySelector('[data-count]');
    var apply=function(){
      var diet=(f.querySelector('input[name=diet]:checked')||{}).value||'all';
      var avoid=[].slice.call(f.querySelectorAll('input[name=avoid]:checked')).map(function(i){return i.value});
      var shown=0;
      dishes.forEach(function(d){
        var any=false;
        [].slice.call(d.querySelectorAll('tr[data-diet]')).forEach(function(r){
          var dt=r.getAttribute('data-diet'),al=r.getAttribute('data-allergens')||'';
          var okDiet=diet==='all'||(diet==='veg'&&(dt==='v'||dt==='vg'))||diet===dt;
          var okAl=avoid.every(function(a){return al.indexOf(a)===-1});
          var ok=okDiet&&okAl;r.classList.toggle('is-hidden',!ok);if(ok)any=true;
        });
        d.parentNode.classList.toggle('is-hidden',!any);if(any)shown++;
      });
      count.textContent=shown+' of '+dishes.length+' dishes';
    };
    f.addEventListener('change',apply);apply();
  }
})();

// tasting-menu carousel
(function(){
  [].slice.call(document.querySelectorAll('[data-carousel]')).forEach(function(root){
    var track=root.querySelector('[data-track]'),slides=[].slice.call(root.querySelectorAll('[data-slide]'));
    if(!track||!slides.length)return;
    var cur=root.querySelector('[data-current]'),bar=root.querySelector('[data-bar]'),prev=root.querySelector('[data-prev]'),next=root.querySelector('[data-next]');
    var idx=0;
    var pad=function(n){return (n<10?'0':'')+n};
    var set=function(i){
      idx=i;slides.forEach(function(s,k){s.classList.toggle('is-active',k===i)});
      if(cur)cur.textContent=pad(i+1);
      if(bar)bar.style.width=((i+1)/slides.length*100)+'%';
      if(prev)prev.disabled=i===0; if(next)next.disabled=i===slides.length-1;
    };
    var go=function(i){i=Math.max(0,Math.min(slides.length-1,i));var s=slides[i];track.scrollTo({left:s.offsetLeft-(track.clientWidth-s.clientWidth)/2});};
    var t;track.addEventListener('scroll',function(){clearTimeout(t);t=setTimeout(function(){
      var c=track.scrollLeft+track.clientWidth/2,best=0,bd=1e9;
      slides.forEach(function(s,k){var d=Math.abs(s.offsetLeft+s.clientWidth/2-c);if(d<bd){bd=d;best=k}});set(best);},60)},{passive:true});
    if(prev)prev.addEventListener('click',function(){go(idx-1)});
    if(next)next.addEventListener('click',function(){go(idx+1)});
    track.addEventListener('keydown',function(e){if(e.key==='ArrowRight'){e.preventDefault();go(idx+1)}if(e.key==='ArrowLeft'){e.preventDefault();go(idx-1)}});
    slides.forEach(function(s,k){s.addEventListener('click',function(){if(k!==idx)go(k)})});
    set(0);
  });
})();
